var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCityNeighbourhood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "65.6 135.78 65.6 18.32 121.72 18.32 121.72 93.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.13,
    y1: 33.29,
    x2: 80.13,
    y2: 39.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.13,
    y1: 51.63,
    x2: 80.13,
    y2: 57.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.13,
    y1: 71.32,
    x2: 80.13,
    y2: 77.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 80.13,
    y1: 89.65,
    x2: 80.13,
    y2: 93.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.89,
    y1: 33.29,
    x2: 93.89,
    y2: 39.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.89,
    y1: 51.63,
    x2: 93.89,
    y2: 57.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.89,
    y1: 71.32,
    x2: 93.89,
    y2: 77.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.89,
    y1: 89.65,
    x2: 93.89,
    y2: 93.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.65,
    y1: 33.29,
    x2: 107.65,
    y2: 39.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.65,
    y1: 51.63,
    x2: 107.65,
    y2: 57.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.65,
    y1: 71.32,
    x2: 107.65,
    y2: 77.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.65,
    y1: 89.65,
    x2: 107.65,
    y2: 93.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "122.02 59.46 185.11 59.46 185.11 186.16 140.22 186.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "76.69 144.38 76.69 95.22 142.67 95.22 142.67 186.16 84.81 186.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 134.86,
    y1: 71.68,
    x2: 134.86,
    y2: 78.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 154.08,
    y1: 71.68,
    x2: 154.08,
    y2: 78.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172.89,
    y1: 71.68,
    x2: 172.89,
    y2: 78.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172.89,
    y1: 97.48,
    x2: 172.89,
    y2: 104.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172.89,
    y1: 147.73,
    x2: 172.89,
    y2: 154.52
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "166.09 183.72 166.09 166.74 153.19 166.74 153.19 185.75"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 172.89,
    y1: 122.6,
    x2: 172.89,
    y2: 129.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 153.87,
    y1: 97.48,
    x2: 153.87,
    y2: 104.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 153.87,
    y1: 147.73,
    x2: 153.87,
    y2: 154.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 153.87,
    y1: 122.6,
    x2: 153.87,
    y2: 129.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.05,
    y: 111.18,
    width: 12.9,
    height: 13.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 115.85,
    y: 111.18,
    width: 12.9,
    height: 13.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 90.05,
    y: 136.42,
    width: 12.9,
    height: 13.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 115.85,
    y: 136.42,
    width: 12.9,
    height: 13.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "32.86 150.12 32.86 198.24 83.92 198.24 83.92 150.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "24.22 155.89 58.29 132.94 92.36 155.75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityNeighbourhood);
export default __webpack_public_path__ + "static/media/CITY_NEIGHBOURHOOD.8ca754a1125d5b3b6e97ee82a2420b43.svg";
export { ForwardRef as ReactComponent };